import { useState, useRef, useEffect } from "react";

interface UserAgreementModalProps {
  show: boolean;
  onClose: () => void;
  onAgree: () => void;
  pdfImages?: string[]; // array URL PNG halaman PDF
}

export default function UserAgreementModal({
  show,
  onClose,
  onAgree,
  pdfImages = [
    "/assets/pdf/user-aggreement_page-0001.jpg",
    "/assets/pdf/user-aggreement_page-0002.jpg",
    "/assets/pdf/user-aggreement_page-0003.jpg",
    "/assets/pdf/user-aggreement_page-0004.jpg",
    "/assets/pdf/user-aggreement_page-0005.jpg",
    // tambahkan semua halaman PNG PDF kamu
  ],
}: UserAgreementModalProps) {
  const [canAgree, setCanAgree] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  // reset canAgree tiap kali modal dibuka
  useEffect(() => {
    if (show) setCanAgree(false);
  }, [show]);

  const handleScroll = () => {
    if (!containerRef.current) return;
    const el = containerRef.current;
    // jika scroll sampai bawah ±5px
    if (el.scrollTop + el.clientHeight >= el.scrollHeight - 5) {
      setCanAgree(true);
    }
  };

  return show ? (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-white w-full max-w-md md:max-w-3xl rounded-xl shadow-lg flex flex-col">

        {/* Header */}
        <div className="px-6 py-4 border-b">
          <h3 className="text-lg font-semibold">User Agreement</h3>
        </div>

        {/* Scrollable content */}
        <div
          ref={containerRef}
          onScroll={handleScroll}
          className="px-4 py-2 h-96 overflow-y-auto"
        >
          {pdfImages.map((src, i) => (
            <img
              key={i}
              src={src}
              alt={`User Agreement Page ${i + 1}`}
              className="w-full mb-4 rounded"
            />
          ))}
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t flex justify-end gap-2">
          <button
            onClick={onClose}
            className="bg-gray-300 text-black px-4 py-2 rounded"
          >
            Close
          </button>

          <button
            onClick={onAgree}
            disabled={!canAgree}
            className={`px-4 py-2 rounded text-white ${
              canAgree
                ? "bg-primary hover:bg-secondary"
                : "bg-gray-300 cursor-not-allowed"
            }`}
          >
            I Agree
          </button>
        </div>
      </div>
    </div>
  ) : null;
}
